/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * Helper to check file exist in PC directory
 *
 * @author Anton Panasenko
 * @version 1.3.0
 * @since 1.3.0
 */


export const checkIsFileExist = (file: File): Promise<boolean> => {
    const oneByte: Blob = file.slice(0, 1);
    return new Promise<void>((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve()
        reader.onerror = () => reject()
        reader.readAsText(oneByte);
    })
        .then(() => true)
        .catch(() => false)
}
